import {
    CREATING_DASHBOARD,
    CREATING_DASHBOARD_FAILURE,
    CREATING_DASHBOARD_SUCCESS,
    RESET_CREATING_DASHBOARD_SUCCESS,
    GETTING_DASHBOARDS_BY_SITE,
    GETTING_DASHBOARDS_BY_SITE_SUCCESS,
    GETTING_DASHBOARDS_BY_SITE_FAILURE,
    RESET_GETTING_DASHBOARDS_BY_SITE,
    UPDATING_DASHBOARD,
    UPDATING_DASHBOARD_SUCCESS,
    UPDATING_DASHBOARD_FAILURE,
    RESET_UPDATING_DASHBOARD,
    UPDATING_DASHBOARDS,
    UPDATING_DASHBOARDS_SUCCESS,
    UPDATING_DASHBOARDS_FAILURE,
    RESET_UPDATING_DASHBOARDS,
    DELETING_DASHBOARD,
    DELETING_DASHBOARD_SUCCESS,
    DELETING_DASHBOARD_FAILURE,
    RESET_DELETING_DASHBOARD,
    UPDATING_DASHBOARD_LINKS,
    UPDATING_DASHBOARD_LINKS_SUCCESS,
    UPDATING_DASHBOARD_LINKS_FAILURE,
    RESET_UPDATING_DASHBOARD_LINKS,
    ADDING_INFO_ITEM,
    ADDING_INFO_ITEM_SUCCESS,
    ADDING_INFO_ITEM_FAILURE,
    RESET_ADDING_INFO_ITEM,
    UPDATING_INFO_ITEM,
    UPDATING_INFO_ITEM_SUCCESS,
    UPDATING_INFO_ITEM_FAILURE,
    RESET_UPDATING_INFO_ITEM,
    GETTING_DASHBOARD,
    GETTING_DASHBOARD_SUCCESS,
    GETTING_DASHBOARD_FAILURE,
    RESET_GETTING_DASHBOARD,
    DELETING_INFO_ITEM,
    DELETING_INFO_ITEM_SUCCESS,
    DELETING_INFO_ITEM_FAILURE,
    RESET_DELETING_INFO_ITEM,
    ADDING_LINK,
    ADDING_LINK_SUCCESS,
    ADDING_LINK_FAILURE,
    RESET_ADDING_LINK,
    GETTING_LINK,
    GETTING_LINK_SUCCESS,
    GETTING_LINK_FAILURE,
    RESET_GETTING_LINK,
    DELETING_LINK,
    DELETING_LINK_SUCCESS,
    DELETING_LINK_FAILURE,
    RESET_DELETING_LINK,
    EDITING_LINK,
    EDITING_LINK_SUCCESS,
    EDITING_LINK_FAILURE,
    RESET_EDITING_LINK,
    GETTING_URL,
    GETTING_URL_SUCCESS,
    GETTING_URL_FAILURE,
    RESET_GETTING_URL,
    SENDING_LINK_HIT,
    SENDING_LINK_HIT_SUCCESS,
    SENDING_LINK_HIT_FAILURE,
    RESET_SENDING_LINK_HIT,
    DELETING_DASHBOARDS,
    DELETING_DASHBOARDS_SUCCESS,
    DELETING_DASHBOARDS_FAILURE,
    RESET_DELETING_DASHBOARDS,
    SENDING_DASHBOARD_HIT,
    SENDING_DASHBOARD_HIT_SUCCESS,
    SENDING_DASHBOARD_HIT_FAILURE,
    DELETING_LINKS,
    DELETING_LINKS_SUCCESS,
    DELETING_LINKS_FAILURE,
    RESET_DELETING_LINKS,
    GETTING_MY_DASHBOARDS,
    GETTING_MY_DASHBOARDS_SUCCESS,
    GETTING_MY_DASHBOARDS_FAILURE,
    RESET_GETTING_MY_DASHBOARDS,
    ADDING_CONTRIBUTOR_SUCCESS,
    UPDATING_CONTRIBUTOR_SUCCESS,
    DELETING_CONTRIBUTOR_SUCCESS,
    UPLOADING_DASHBOARD_PHOTO,
    UPLOADING_DASHBOARD_PHOTO_SUCCESS,
    UPLOADING_DASHBOARD_PHOTO_FAILURE,
    RESET_UPLOADING_DASHBOARD_PHOTO,
    DELETING_DASHBOARD_PHOTO,
    DELETING_DASHBOARD_PHOTO_SUCCESS,
    DELETING_DASHBOARD_PHOTO_FAILURE,
    RESET_DELETING_DASHBOARD_PHOTO,
    TRIGGERED_BULK_UPLOAD
} from 'redux/reduxConstants';

const initialState = {
    gettingDashboard: false,
    gettingDashboardSuccess: false,
    creatingDashboard: false,
    creatingDashboardSuccess: false,
    gettingDashboardsForSite: false,
    gettingDashboardsForSiteSuccess: false,
    updatingDashboard: false,
    updatingDashboardSuccess: false,
    updatingDashboards: false,
    updatingDashboardsSuccess: false,
    updatingDashboardLinks: false,
    updatingDashboardLinksSuccess: false,
    addingInfoItem: false,
    addingInfoItemSuccess: false,
    updatingInfoItem: false,
    updatingInfoItemSuccess: false,
    deletingInfoItem: false,
    deletingInfoItemSuccess: false,
    addingLink: false,
    addingLinkSuccess: false,
    gettingLink: false,
    gettingLinkSuccess: false,
    deletingLink: false,
    deletingLinkSuccess: false,
    editingLink: false,
    editingLinkSuccess: false,
    gettingUrl: false,
    gettingUrlSuccess: false,
    sendingLinkHit: false,
    sendingLinkHitSuccess: false,
    deletingDashboards: false,
    deletingLinks: false,
    deletingDashboardsSuccess: false,
    deletingLinksSuccess: false,
    sendingDashboardHit: false,
    sendingDashboardHitSuccess: false,
    sendingDashboardHitFailure: false,
    gettingMyDashboards: false,
    gettingMyDashboardsSuccess: false,
    uploadingDashboardPhoto: false,
    uploadingDashboardPhotoSuccess: false,
    deletingDashboardPhoto: false,
    deletingDashboardPhotoSuccess: false,
    url: '',
    link: {},
    newInfoItem: {},
    dashboards: [],
    newDashboard: {},
    selectedDashboard: {},
    triggeredBulkUpload: false,
    error: '',
};

const dashboard = (state = initialState, action) => {
    switch (action.type) {
        case CREATING_DASHBOARD:
            let creatingDashboardState = { ...state };
            creatingDashboardState.creatingDashboard = true;

            return creatingDashboardState;
        case CREATING_DASHBOARD_SUCCESS:
            let creatingDashboardSuccessState = { ...state };
            creatingDashboardSuccessState.creatingDashboard = false;
            creatingDashboardSuccessState.creatingDashboardSuccess = true;
            creatingDashboardSuccessState.newDashboard = action.newDashboard;

            return creatingDashboardSuccessState;
        case CREATING_DASHBOARD_FAILURE:
            let creatingDashboardFailureState = { ...state };
            creatingDashboardFailureState.creatingDashboard = false;
            creatingDashboardFailureState.error = action.error;

            return creatingDashboardFailureState;
        case RESET_CREATING_DASHBOARD_SUCCESS:
            let resetCreatingDashboardSuccess = { ...state };
            resetCreatingDashboardSuccess.newDashboard = {};
            resetCreatingDashboardSuccess.creatingDashboardSuccess = false;

            return resetCreatingDashboardSuccess;

        case GETTING_DASHBOARD:
            let gettingDashboardState = { ...state };
            gettingDashboardState.gettingDashboard = true;

            return gettingDashboardState;

        case GETTING_DASHBOARD_SUCCESS:
            let gettingDashboardSuccessState = { ...state };
            gettingDashboardSuccessState.gettingDashboard = false;
            gettingDashboardSuccessState.gettingDashboardSuccess = true;
            gettingDashboardSuccessState.selectedDashboard = action.dashboard;

            return gettingDashboardSuccessState;

        case GETTING_DASHBOARD_FAILURE:
            let gettingDashboardFailureState = { ...state };
            gettingDashboardFailureState.gettingDashboard = false;
            gettingDashboardFailureState.error = action.error;

            return gettingDashboardFailureState;

        case RESET_GETTING_DASHBOARD:
            let resetGettingDashboardSuccess = { ...state };
            resetGettingDashboardSuccess.gettingDashboardSuccess = false;

            return resetGettingDashboardSuccess;

        case GETTING_DASHBOARDS_BY_SITE:
            let gettingDashboardsBySiteState = { ...state };
            gettingDashboardsBySiteState.gettingDashboardsForSite = true;

            return gettingDashboardsBySiteState;

        case GETTING_DASHBOARDS_BY_SITE_SUCCESS:
            let gettingDashboardsBySiteSuccessState = { ...state };
            gettingDashboardsBySiteSuccessState.gettingDashboardsForSite = false;
            gettingDashboardsBySiteSuccessState.gettingDashboardsForSiteSuccess = true;
            action.dashboards.sort((a, b) => {
                if (a.name.toUpperCase() > b.name.toUpperCase()) {
                    return 1;
                }
                if (b.name.toUpperCase() > a.name.toUpperCase()) {
                    return -1;
                }

                return 0;
            });
            gettingDashboardsBySiteSuccessState.dashboards = action.dashboards;

            return gettingDashboardsBySiteSuccessState;

        case GETTING_DASHBOARDS_BY_SITE_FAILURE:
            let gettingDashboardsBySiteFailureState = { ...state };
            gettingDashboardsBySiteFailureState.gettingDashboardsForSite = false;
            gettingDashboardsBySiteFailureState.error = action.error;

            return gettingDashboardsBySiteFailureState;

        case RESET_GETTING_DASHBOARDS_BY_SITE:
            let resetGettingDashboardsBySiteState = { ...state };
            resetGettingDashboardsBySiteState.gettingDashboardsForSiteSuccess = false;

            return resetGettingDashboardsBySiteState;

        case UPDATING_DASHBOARD:
            let updatingDashboardState = { ...state };
            updatingDashboardState.updatingDashboard = true;

            return updatingDashboardState;

        case UPDATING_DASHBOARD_SUCCESS:
            let updatingDashboardSuccessState = { ...state };
            updatingDashboardSuccessState.updatingDashboard = false;
            updatingDashboardSuccessState.updatingDashboardSuccess = true;
            updatingDashboardSuccessState.selectedDashboard.name = action.dashboard.name;
            updatingDashboardSuccessState.selectedDashboard.owner.name = action.dashboard.owner;
            updatingDashboardSuccessState.selectedDashboard.owner.email = action.dashboard.email;

            return updatingDashboardSuccessState;

        case UPDATING_DASHBOARD_FAILURE:
            let updatingDashboardFailureState = { ...state };
            updatingDashboardFailureState.updatingDashboard = false;
            updatingDashboardFailureState.error = action.error;

            return updatingDashboardFailureState;

        case RESET_UPDATING_DASHBOARD:
            let resetUpdatingDashboardState = { ...state };
            resetUpdatingDashboardState.updatingDashboardSuccess = false;

            return resetUpdatingDashboardState;

        case UPDATING_DASHBOARDS:
            let updatingDashboardsState = { ...state };
            updatingDashboardsState.updatingDashboards = true;

            return updatingDashboardsState;

        case UPDATING_DASHBOARDS_SUCCESS:
            let updatingDashboardsSuccessState = { ...state };
            updatingDashboardsSuccessState.updatingDashboards = false;
            updatingDashboardsSuccessState.updatingDashboardsSuccess = true;

            return updatingDashboardsSuccessState;

        case UPDATING_DASHBOARDS_FAILURE:
            let updatingDashboardsFailureState = { ...state };
            updatingDashboardsFailureState.updatingDashboards = false;
            updatingDashboardsFailureState.error = action.error;

            return updatingDashboardsFailureState;

        case RESET_UPDATING_DASHBOARDS:
            let resetUpdatingDashboardsState = { ...state };
            resetUpdatingDashboardsState.updatingDashboardsSuccess = false;

            return resetUpdatingDashboardsState;

        case DELETING_DASHBOARD:
            let deletingDashboardState = { ...state };
            deletingDashboardState.deletingDashboard = true;

            return deletingDashboardState;

        case DELETING_DASHBOARD_SUCCESS:
            let deletingDashboardSuccessState = { ...state };
            deletingDashboardSuccessState.deletingDashboard = false;
            deletingDashboardSuccessState.deletingDashboardSuccess = true;

            return deletingDashboardSuccessState;

        case DELETING_DASHBOARD_FAILURE:
            let deletingDashboardFailureState = { ...state };
            deletingDashboardFailureState.error = action.error;
            deletingDashboardFailureState.deletingContributor = false;

            return deletingDashboardFailureState;

        case RESET_DELETING_DASHBOARD:
            let resetDeletingDashboard = { ...state };
            resetDeletingDashboard.deletingDashboardSuccess = false;

            return resetDeletingDashboard;

        case UPDATING_DASHBOARD_LINKS:
            let updatingDashboardLinksState = { ...state };
            updatingDashboardLinksState.updatingDashboardLinks = true;

            return updatingDashboardLinksState;

        case UPDATING_DASHBOARD_LINKS_SUCCESS:
            let updatingDashboardLinksSuccessState = { ...state };
            updatingDashboardLinksSuccessState.updatingDashboardLinks = false;
            updatingDashboardLinksSuccessState.updatingDashboardLinksSuccess = true;

            return updatingDashboardLinksSuccessState;

        case UPDATING_DASHBOARD_LINKS_FAILURE:
            let updatingDashboardLinksFailureState = { ...state };
            updatingDashboardLinksFailureState.updatingDashboardLinks = false;
            updatingDashboardLinksFailureState.error = action.error;

            return updatingDashboardLinksFailureState;

        case RESET_UPDATING_DASHBOARD_LINKS:
            let resetUpdatingDashboardLinksState = { ...state };
            resetUpdatingDashboardLinksState.updatingDashboardLinksSuccess = false;

            return resetUpdatingDashboardLinksState;

        case ADDING_INFO_ITEM:
            let addingInfoItemState = { ...state };
            addingInfoItemState.addingInfoItem = true;

            return addingInfoItemState;

        case ADDING_INFO_ITEM_SUCCESS:
            let addingInfoItemSuccessState = { ...state };
            addingInfoItemSuccessState.addingInfoItem = false;
            addingInfoItemSuccessState.addingInfoItemSuccess = true;

            let updatedSelectedDashboard = { ...addingInfoItemSuccessState.selectedDashboard };
            updatedSelectedDashboard.info = action.newInfoItem;

            addingInfoItemSuccessState.selectedDashboard = updatedSelectedDashboard;

            return addingInfoItemSuccessState;

        case ADDING_INFO_ITEM_FAILURE:
            let addingInfoItemFailureState = { ...state };
            addingInfoItemFailureState.addingInfoItem = false;
            addingInfoItemFailureState.error = action.error;

            return addingInfoItemFailureState;

        case RESET_ADDING_INFO_ITEM:
            let resetAddingInfoItemState = { ...state };
            resetAddingInfoItemState.addingInfoItemSuccess = false;
            resetAddingInfoItemState.newInfoItem = {};

            return resetAddingInfoItemState;

        case UPDATING_INFO_ITEM:
            let updatingInfoItemState = { ...state };
            updatingInfoItemState.updatingInfoItem = true;

            return updatingInfoItemState;

        case UPDATING_INFO_ITEM_SUCCESS:
            let updatingInfoItemSuccessState = { ...state };
            updatingInfoItemSuccessState.updatingInfoItem = false;
            updatingInfoItemSuccessState.updatingInfoItemSuccess = true;

            let updatedSelectedDashboardInfoItemSuccess = updatingInfoItemSuccessState.selectedDashboard;

            let updatedInfoItems = updatedSelectedDashboardInfoItemSuccess.info.map((infoItem) => {
                if (infoItem.id === action.updatedInfoItem.id) {
                    return action.updatedInfoItem;
                }

                return infoItem;
            });

            updatedSelectedDashboardInfoItemSuccess.info = updatedInfoItems;
            updatingInfoItemSuccessState.selectedDashboard = updatedSelectedDashboardInfoItemSuccess;

            return updatingInfoItemSuccessState;

        case UPDATING_INFO_ITEM_FAILURE:
            let updatingInfoItemFailureState = { ...state };
            updatingInfoItemFailureState.updatingInfoItem = false;
            updatingInfoItemFailureState.error = action.error;

            return updatingInfoItemFailureState;

        case RESET_UPDATING_INFO_ITEM:
            let resetUpdatingInfoItemState = { ...state };
            resetUpdatingInfoItemState.updatingInfoItemSuccess = false;

            return resetUpdatingInfoItemState;

        case DELETING_INFO_ITEM:
            let deletingInfoItemState = { ...state };
            deletingInfoItemState.deletingInfoItem = true;

            return deletingInfoItemState;

        case DELETING_INFO_ITEM_SUCCESS:
            let deletingInfoItemSuccessState = { ...state };
            deletingInfoItemSuccessState.deletingInfoItem = false;
            deletingInfoItemSuccessState.deletingInfoItemSuccess = true;

            let updatedSelectedDashboardDelInfoItemSuccess = { ...deletingInfoItemSuccessState.selectedDashboard };

            let updatedInfoItemsForDeleteSuccess = [];
            updatedSelectedDashboardDelInfoItemSuccess.info.forEach((infoItem) => {
                if (infoItem.id !== action.deletedInfoItem.id) {
                    updatedInfoItemsForDeleteSuccess.push(infoItem);
                }
            });

            updatedSelectedDashboardDelInfoItemSuccess.info = updatedInfoItemsForDeleteSuccess;
            deletingInfoItemSuccessState.selectedDashboard = updatedSelectedDashboardDelInfoItemSuccess;
            return deletingInfoItemSuccessState;

        case DELETING_INFO_ITEM_FAILURE:
            let deletingInfoItemFailureState = { ...state };
            deletingInfoItemFailureState.error = action.error;
            deletingInfoItemFailureState.deletingInfoItem = false;

            return deletingInfoItemFailureState;

        case RESET_DELETING_INFO_ITEM:
            let resetDeletingInfoItem = { ...state };
            resetDeletingInfoItem.deletingInfoItemSuccess = false;

            return resetDeletingInfoItem;

        case ADDING_LINK:
            let addingLinkState = { ...state };
            addingLinkState.addingLink = true;

            return addingLinkState;

        case ADDING_LINK_SUCCESS:
            let addingLinkSuccessState = { ...state };
            addingLinkSuccessState.addingLink = false;
            addingLinkSuccessState.addingLinkSuccess = true;

            let updatedDashboardForAddingLinkSuccess = { ...addingLinkSuccessState.selectedDashboard };
            let updatedLinksForAddingLinkSuccess = [...updatedDashboardForAddingLinkSuccess.links];
            //set the isInteral property that public icon is displayed based off of because the API does not set that property on postLink
            action.newLink.isInternal = action.newLink.URL.includes('.xom') || action.newLink.URL.includes('goto/');
            updatedLinksForAddingLinkSuccess.push(action.newLink);

            updatedDashboardForAddingLinkSuccess.links = updatedLinksForAddingLinkSuccess;
            addingLinkSuccessState.selectedDashboard = updatedDashboardForAddingLinkSuccess;

            return addingLinkSuccessState;

        case ADDING_LINK_FAILURE:
            let addingLinkFailureState = { ...state };
            addingLinkFailureState.addingLink = false;
            addingLinkFailureState.error = action.error;

            return addingLinkFailureState;

        case RESET_ADDING_LINK:
            let resetAddingLinkState = { ...state };
            resetAddingLinkState.addingLinkSuccess = false;

            return resetAddingLinkState;

        case GETTING_URL:
            let gettingUrlState = { ...state };
            gettingUrlState.gettingUrl = true;

            return gettingUrlState;

        case GETTING_URL_SUCCESS:
            let gettingUrlSuccessState = { ...state };
            gettingUrlSuccessState.gettingUrlSuccess = true;
            gettingUrlSuccessState.gettingUrl = false;
            gettingUrlSuccessState.url = action.link;
            return gettingUrlSuccessState;

        case GETTING_URL_FAILURE:
            let gettingUrlFailureState = { ...state };
            gettingUrlFailureState.gettingUrl = false;

            gettingUrlFailureState.error = '';
            return gettingUrlFailureState;

        case RESET_GETTING_URL:
            let resetGettingUrlState = { ...state };
            resetGettingUrlState.gettingUrlSuccess = false;
            resetGettingUrlState.url = '';

            return resetGettingUrlState;

        case GETTING_LINK:
            let gettingLinkState = { ...state };
            gettingLinkState.gettingLink = true;

            return gettingLinkState;

        case GETTING_LINK_SUCCESS:
            let gettingLinkSuccessState = { ...state };
            gettingLinkSuccessState.gettingLinkSuccess = true;
            gettingLinkSuccessState.gettingLink = false;
            gettingLinkSuccessState.link = action.link;
            return gettingLinkSuccessState;

        case GETTING_LINK_FAILURE:
            let gettingLinkFailureState = { ...state };
            gettingLinkFailureState.gettingLink = false;

            gettingLinkFailureState.error = '';
            return gettingLinkFailureState;

        case RESET_GETTING_LINK:
            let resetGettingLinkState = { ...state };
            resetGettingLinkState.gettingLinkSuccess = false;
            resetGettingLinkState.link = {};

            return resetGettingLinkState;

        case EDITING_LINK:
            let editingLinkState = { ...state };
            editingLinkState.editingLink = true;

            return editingLinkState;

        case EDITING_LINK_SUCCESS:
            let editingLinkSuccessState = { ...state };
            editingLinkSuccessState.editingLinkSuccess = true;
            editingLinkSuccessState.editingLink = false;

            let selectedDashboardForEditingLink = { ...editingLinkSuccessState.selectedDashboard };
            let updatedLinks = selectedDashboardForEditingLink.links.map((link) => {
                if (link.linkId === action.updatedLink.linkId) {
                    const { URL, ...updatedLink } = action.updatedLink;
                    return updatedLink;
                }

                return link;
            });

            selectedDashboardForEditingLink.links = updatedLinks;
            editingLinkSuccessState.selectedDashboard = selectedDashboardForEditingLink;
            return editingLinkSuccessState;

        case EDITING_LINK_FAILURE:
            let editingLinkFailureState = { ...state };
            editingLinkFailureState.editingLink = false;

            editingLinkFailureState.error = '';
            return editingLinkFailureState;

        case RESET_EDITING_LINK:
            let resetEditingLinkState = { ...state };
            resetEditingLinkState.editingLinkSuccess = false;

            return resetEditingLinkState;

        case DELETING_LINK:
            let deletingLinkState = { ...state };
            deletingLinkState.deletingLink = true;

            return deletingLinkState;

        case DELETING_LINK_SUCCESS:
            let deletingLinkSuccessState = { ...state };
            deletingLinkSuccessState.deletingLinkSuccess = true;
            deletingLinkSuccessState.deletingLink = false;

            let selectedDashboardForDeletingLink = { ...deletingLinkSuccessState.selectedDashboard };
            let updatedLinksForDelete = [];
            selectedDashboardForDeletingLink.links.forEach((link) => {
                if (link.linkId !== action.linkId) {
                    updatedLinksForDelete.push(link);
                }
            });

            selectedDashboardForDeletingLink.links = updatedLinksForDelete;
            deletingLinkSuccessState.selectedDashboard = selectedDashboardForDeletingLink;

            return deletingLinkSuccessState;

        case DELETING_LINK_FAILURE:
            let deletingLinkFailureState = { ...state };
            deletingLinkFailureState.deletingLink = false;

            deletingLinkFailureState.error = action.error;
            return deletingLinkFailureState;

        case RESET_DELETING_LINK:
            let resetDeletingLinkState = { ...state };
            resetDeletingLinkState.deletingLinkSuccess = false;

            return resetDeletingLinkState;

        case SENDING_LINK_HIT:
            let sendingLinkHitState = { ...state };
            sendingLinkHitState.sendingLinkHit = true;

            return sendingLinkHitState;

        case SENDING_LINK_HIT_SUCCESS:
            let sendingLinkHitSuccessState = { ...state };
            sendingLinkHitSuccessState.sendingLinkHitSuccess = true;
            sendingLinkHitSuccessState.sendingLinkHit = false;

            return sendingLinkHitSuccessState;

        case SENDING_LINK_HIT_FAILURE:
            let sendingLinkHitFailureState = { ...state };
            sendingLinkHitFailureState.sendingLinkHit = false;
            sendingLinkHitFailureState.error = action.error;

            return sendingLinkHitFailureState;

        case RESET_SENDING_LINK_HIT:
            let resetSendingLinkHitState = { ...state };
            resetSendingLinkHitState.sendingLinkHitSuccess = false;

            return resetSendingLinkHitState;

        case DELETING_DASHBOARDS:
            let deletingDashboardsState = { ...state };
            deletingDashboardsState.deletingDashboards = true;
            deletingDashboardsState.deletingDashboardsSuccess = false;

            return deletingDashboardsState;

        case SENDING_DASHBOARD_HIT:
            let sendingDashboardHitState = { ...state };
            sendingDashboardHitState.sendingDashboardHit = true;

            return sendingDashboardHitState;
        
        case SENDING_DASHBOARD_HIT_SUCCESS:
            let sendingDashboardHitSuccessState = { ...state };
            sendingDashboardHitSuccessState.sendingDashboardHitSuccess = true;

            return sendingDashboardHitSuccessState;

        case SENDING_DASHBOARD_HIT_FAILURE:
            let sendingDashboardHitFailureState = { ...state };
            sendingDashboardHitFailureState.sendingDashboardHitFailure = true;

            return sendingDashboardHitFailureState;

        case DELETING_DASHBOARDS_SUCCESS:
            let deletingDashboardsSuccessState = { ...state };
            deletingDashboardsSuccessState.deletingDashboards = false;
            deletingDashboardsSuccessState.deletingDashboardsSuccess = true;

            let dashboardsForDeletingSuccess = [];

            deletingDashboardsSuccessState.dashboards.forEach((dashboard) => {
                if (!action.dashboards.some((deletedDashboard) => deletedDashboard.dashboardId === dashboard.dashboardId)) {
                    dashboardsForDeletingSuccess.push(dashboard);
                }
            });

            deletingDashboardsSuccessState.dashboards = dashboardsForDeletingSuccess;

            return deletingDashboardsSuccessState;

        case DELETING_DASHBOARDS_FAILURE:
            let deletingDashboardsFailureState = { ...state };
            deletingDashboardsFailureState.deletingDashboards = false;
            deletingDashboardsFailureState.error = action.error;
            return deletingDashboardsFailureState;

        case RESET_DELETING_DASHBOARDS:
            let resetDeletingDashboardsState = { ...state };
            resetDeletingDashboardsState.deletingDashboardsSuccess = false;

            return resetDeletingDashboardsState;

        case DELETING_LINKS:
            let deletingLinksState = { ...state };
            deletingLinksState.deletingLinks = true;

            return deletingLinksState;

        case DELETING_LINKS_SUCCESS:
            let deletingLinksSuccessState = { ...state };
            deletingLinksSuccessState.deletingLinks = false;
            deletingLinksSuccessState.deletingLinksSuccess = true;

            let selectedDashboardForDeleteSuccess = { ...deletingLinksSuccessState.selectedDashboard };
            let linksdsForDeletingSuccess = [];

            selectedDashboardForDeleteSuccess.links.forEach((link) => {
                if (!action.links.some((deletedLink) => deletedLink.linkId === link.linkId)) {
                    linksdsForDeletingSuccess.push(link);
                }
            });

            selectedDashboardForDeleteSuccess.links = linksdsForDeletingSuccess;
            deletingLinksSuccessState.selectedDashboard = selectedDashboardForDeleteSuccess;
            return deletingLinksSuccessState;

        case DELETING_LINKS_FAILURE:
            let deletingLinksFailureState = { ...state };
            deletingLinksFailureState.deletingLinks = false;
            deletingLinksFailureState.error = action.error;

            return deletingLinksFailureState;

        case RESET_DELETING_LINKS:
            let resetDeletingLinksState = { ...state };
            resetDeletingLinksState.deletingLinksSuccess = false;

            return resetDeletingLinksState;

        case GETTING_MY_DASHBOARDS:
            let gettingMyDashboardsState = { ...state };
            gettingMyDashboardsState.gettingMyDashboards = true;

            return gettingMyDashboardsState;

        case GETTING_MY_DASHBOARDS_SUCCESS:
            let gettingMyDashboardsSuccessState = { ...state };
            gettingMyDashboardsSuccessState.gettingMyDashboards = false;
            gettingMyDashboardsSuccessState.gettingMyDashboardsSuccess = true;
            gettingMyDashboardsSuccessState.dashboards = action.dashboards;

            return gettingMyDashboardsSuccessState;

        case GETTING_MY_DASHBOARDS_FAILURE:
            let gettingMyDashboardsFailureState = { ...state };
            gettingMyDashboardsFailureState.gettingMyDashboards = false;
            gettingMyDashboardsFailureState.error = action.error;

            return gettingMyDashboardsFailureState;

        case RESET_GETTING_MY_DASHBOARDS:
            let resetGettingMyDashboardsState = { ...state };
            resetGettingMyDashboardsState.gettingMyDashboardsSuccess = false;

            return resetGettingMyDashboardsState;

        case ADDING_CONTRIBUTOR_SUCCESS:
            let addingContributorSuccessState = { ...state };
            addingContributorSuccessState.selectedDashboard.contributors.push(action.newContributor);

            return addingContributorSuccessState;

        case UPDATING_CONTRIBUTOR_SUCCESS:
            let updatingContributorSuccessState = { ...state };
            let contributorList = updatingContributorSuccessState.selectedDashboard.contributors;

            contributorList.forEach((contributor) => {
                if (contributor.email === action.contributor.email) {
                    contributor.firstName = action.contributor.firstName;
                    contributor.lastName = action.contributor.lastName;
                }
            });

            updatingContributorSuccessState.selectedDashboard.contributors = contributorList;

            return updatingContributorSuccessState;

        case DELETING_CONTRIBUTOR_SUCCESS:
            let deletingContributorSuccessState = { ...state };
            let contributors = deletingContributorSuccessState.selectedDashboard.contributors;
            contributors = contributors.filter((c) => c.email !== action.contributor.userId);

            deletingContributorSuccessState.selectedDashboard.contributors = contributors;

            return deletingContributorSuccessState;

        case UPLOADING_DASHBOARD_PHOTO:
            let uploadingDashboardPhotoState = { ...state };
            uploadingDashboardPhotoState.uploadingDashboardPhoto = true;

            return uploadingDashboardPhotoState;

        case UPLOADING_DASHBOARD_PHOTO_SUCCESS:
            let uploadingDashboardPhotoSuccessState = { ...state };
            uploadingDashboardPhotoSuccessState.uploadingDashboardPhoto = false;
            uploadingDashboardPhotoSuccessState.uploadingDashboardPhotoSuccess = true;
            uploadingDashboardPhotoSuccessState.selectedDashboard.imageUrl = action.dashboard.imageUrl;

            return uploadingDashboardPhotoSuccessState;

        case UPLOADING_DASHBOARD_PHOTO_FAILURE:
            let uploadingDashboardPhotoFailureState = { ...state };
            uploadingDashboardPhotoFailureState.uploadingDashboardPhoto = false;
            uploadingDashboardPhotoFailureState.error = action.error;

            return uploadingDashboardPhotoFailureState;

        case RESET_UPLOADING_DASHBOARD_PHOTO:
            let resetUploadingDashboardPhotoState = { ...state };
            resetUploadingDashboardPhotoState.uploadingDashboardPhotoSuccess = false;

            return resetUploadingDashboardPhotoState;

        case DELETING_DASHBOARD_PHOTO:
            let deletingDashboardPhotoState = { ...state };
            deletingDashboardPhotoState.deletingDashboardPhoto = true;

            return deletingDashboardPhotoState;

        case DELETING_DASHBOARD_PHOTO_SUCCESS:
            let deletingDashboardPhotoSuccessState = { ...state };
            deletingDashboardPhotoSuccessState.deletingDashboardPhoto = false;
            deletingDashboardPhotoSuccessState.deletingDashboardPhotoSuccess = true;
            deletingDashboardPhotoSuccessState.selectedDashboard.imageUrl = '';

            return deletingDashboardPhotoSuccessState;

        case DELETING_DASHBOARD_PHOTO_FAILURE:
            let deletingDashboardPhotoFailureState = { ...state };
            deletingDashboardPhotoFailureState.deletingDashboardPhoto = false;
            deletingDashboardPhotoFailureState.error = action.error;

            return deletingDashboardPhotoFailureState;

        case RESET_DELETING_DASHBOARD_PHOTO:
            let resetDeletingDashboardPhotoState = { ...state };
            resetDeletingDashboardPhotoState.deletingDashboardPhotoSuccess = false;

            return resetDeletingDashboardPhotoState;
        
        case TRIGGERED_BULK_UPLOAD:
                let triggerBulkUploadState = { ...state };
                triggerBulkUploadState.triggeredBulkUpload = action.triggerUpload;
    
                return triggerBulkUploadState;
            
        default:
            return state;
    }
};

export default dashboard;
